<template>
    <div id="view"></div>
</template>

<script>
    import GT3DTryOn from '@/libs/GT3DTryon'
    import {Share} from '@/api/wechat';
    import {modelDtails} from '@/api/modelReq'; 

    export default {
        mounted() {
            modelDtails(this.$route.params.id).then(res=>{
                document.title = `${res.name}-试戴`;
                if(this.$isWeChat) {  
                  Share( `${res.name}-试戴`, res.thumbnail, res.content, window.location.href)  
                }
                this.view =  new GT3DTryOn({
                element: document.getElementById("view"),
                baseUrl: 'https://m.p.gemtec.ltd',
                detail: res
            })
            });
        },
        destroyed() {
            this.view.dispose();
        }
    }
</script>

<style scoped lang="less">
    #view{
        width: 100%;
        height: 100%;
    }
</style>

